export default {"src":"/_next/static/media/ubisoft.db230afd.svg","height":57,"width":177};